export const APP_TERMS_VERSION = "v3";

export const PHONE_USE_CONTRACT_TEMPLATE =
  "Contrato de uso do aparelho próprio\n" +
  "O colaborador que utilizar celular ou tablet próprio para o aplicativo " +
  "AgriConnected poderá receber um adicional no salário, conforme a política " +
  "da fazenda, em razão do uso do equipamento particular no trabalho de campo. " +
  "O valor, a forma de pagamento e a vigência desse adicional são definidos " +
  "pela administração e podem ser descritos nesta cláusula antes da " +
  "assinatura física no escritório.";

export const APP_TERMS_SECTIONS = [
  {
    title: "Como funciona este aplicativo",
    paragraphs: [
      "O aplicativo AgriConnected é uma ferramenta de uso corporativo desenvolvida para registro do diário de bordo de máquinas, coleta de dados operacionais em campo e integração de informações com a plataforma web da fazenda.",
      "Atenção: Este aplicativo funciona exclusivamente como extensão da plataforma AgriConnected. Para utilizá-lo, a fazenda deve possuir uma assinatura ativa e o seu operador precisa estar previamente cadastrado pelo administrador do sistema.",
      "Para saber mais ou contratar, acesse: www.agriconnected.app",
    ],
  },
  {
    title: "Termos de uso e privacidade",
    paragraphs: [
      "Em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018) e com as políticas de privacidade da Google Play Store, apresentamos abaixo como os seus dados são utilizados. O seu aceite consciente é necessário para continuar.",
    ],
  },
  {
    title: "Telemetria",
    bullets: [
      "A localização (GPS) e a velocidade são coletadas EXCLUSIVAMENTE durante a telemetria ativa.",
      "Ao pausar ou finalizar a operação, a coleta de localização é interrompida imediatamente.",
      "O aplicativo não realiza nenhum tipo de rastreamento quando a telemetria estiver desligada ou pausada.",
    ],
  },
  {
    title: "Quando usar a telemetria",
    paragraphs: [
      "Ative a telemetria somente quando estiver efetivamente a serviço da empresa (após o registro de ponto e durante a sua jornada de trabalho). Fora do expediente, a telemetria deve permanecer desligada.",
    ],
  },
  {
    title: "Aviso em tela",
    paragraphs: [
      "Por questões de transparência e segurança operacional, enquanto a telemetria estiver ativa, o aplicativo exibirá um alerta visual na tela do dispositivo a cada 5 minutos, informando que o monitoramento está ligado. O aviso permanece visível por 7 segundos, mesmo com o aplicativo minimizado.",
    ],
  },
  {
    title: "Permissões do dispositivo",
    paragraphs: [
      "O aplicativo poderá solicitar acesso às seguintes permissões do aparelho:",
    ],
    bullets: [
      "Localização (GPS): Utilizada unicamente com a telemetria ativa e para registrar a posição geográfica dos apontamentos de campo.",
      "Câmera: Utilizada para leitura e foto do horímetro/odômetro e registros fotográficos da operação.",
      "Microfone: Utilizado exclusivamente para gravação e envio de áudios e mensagens de rádio no aplicativo.",
    ],
    after: [
      "Essas permissões são restritas ao uso operacional de campo e à sua segurança.",
    ],
  },
  {
    title: "Seu aceite",
    paragraphs: [
      'Ao selecionar "Li e aceito os termos de uso, privacidade e coleta de dados", você confirma ter lido, compreendido e autorizado esta coleta. Este aceite será registrado no seu cadastro de colaborador com data e hora.',
    ],
  },
  {
    title: "Conformidade com a Google Play Store",
    paragraphs: [
      "Este aplicativo foi aprovado sob os critérios de segurança e privacidade da Google Play Store. As permissões solicitadas correspondem rigorosamente ao escopo operacional declarado e aprovado pela loja, sendo vedada e inexistente qualquer coleta de dados fora das condições estipuladas neste documento.",
    ],
  },
];
